import { createContext, useContext, useState, ReactNode } from 'react';
import { ProductDetails } from '../hooks/useEntityDetails';

interface ProductContextType {
  selectedProduct: ProductDetails | null;
  setSelectedProduct: (product: ProductDetails | null) => void;
}

const ProductContext = createContext<ProductContextType | undefined>(undefined);

interface ProductProviderProps {
  children: ReactNode;
}

export function ProductProvider({ children }: ProductProviderProps) {
  const [selectedProduct, setSelectedProduct] = useState<ProductDetails | null>(null);

  return (
    <ProductContext.Provider value={{ selectedProduct, setSelectedProduct }}>
      {children}
    </ProductContext.Provider>
  );
}

export function useProduct() {
  const context = useContext(ProductContext);
  if (context === undefined) {
    throw new Error('useProduct must be used within a ProductProvider');
  }
  return context;
} 